import { render, staticRenderFns } from "./ProductComponent.vue?vue&type=template&id=f7c94a68&scoped=true&"
import script from "./ProductComponent.vue?vue&type=script&lang=js&"
export * from "./ProductComponent.vue?vue&type=script&lang=js&"
import style0 from "./ProductComponent.vue?vue&type=style&index=0&id=f7c94a68&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7c94a68",
  null
  
)

export default component.exports